<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-top:150px;">About the Author</h1><br/>
<p style="text-indent:0px;">A varied and adaptable writer, Joe Clements made his first splash in the world of literature in Flash Fiction Magazine with his intense psychological short, <em>Modern Medicine</em>. Since then he has developed several fictional universes, one of which playing host to his condensed sci-fi epic, <em>System Reset</em>.</p><br/>
<p style="text-indent:0px;">Clements’ dynamic and versatile style is influenced by everything from classic literature and poetry to films, video games, death metal music and even a deep interest in neuroscience and philosophy. A man of emotion, he is eager to invoke a plethora of which within the bleak, extreme and disconcerting.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?1c45916c